import { render, staticRenderFns } from "./StepBody.vue?vue&type=template&id=acc004e6"
import script from "./StepBody.vue?vue&type=script&lang=ts"
export * from "./StepBody.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports